import { academicYearsMatch } from "./reportPeriodUtils";

export const TERM_RECORDS_SCOPES = {
    CURRENT: "current",
    PAST: "past",
};

export function termRowMatchesPeriod(row, term, academicYear) {
    const rowTerm = String(row?.term ?? "").trim();
    const rowYear = String(row?.academicYear ?? "").trim();
    const targetTerm = String(term ?? "").trim();
    const targetYear = String(academicYear ?? "").trim();
    if (!targetTerm && !targetYear) return true;
    if (targetTerm && rowTerm && rowTerm !== targetTerm) return false;
    if (targetYear && rowYear && !academicYearsMatch(rowYear, targetYear)) return false;
    return true;
}

export function filterRowsByTermScope(rows, scope, currentTerm, currentAcademicYear) {
    const list = Array.isArray(rows) ? rows : [];
    if (scope === TERM_RECORDS_SCOPES.PAST) {
        return list.filter((row) => !termRowMatchesPeriod(row, currentTerm, currentAcademicYear));
    }
    if (scope === TERM_RECORDS_SCOPES.CURRENT && (currentTerm || currentAcademicYear)) {
        return list.filter((row) => termRowMatchesPeriod(row, currentTerm, currentAcademicYear));
    }
    return list;
}

export function buildTermRecordsQuery({
    recordsScope = TERM_RECORDS_SCOPES.CURRENT,
    term = "",
    academicYear = "",
    extra = {},
}) {
    const params = { recordsScope, ...extra };
    if (term) params.term = term;
    if (academicYear) params.academicYear = academicYear;
    return params;
}
